module.exports = __webpack_public_path__ + "components/flag/static/square/py-5e272c12a620e68b5ef14b10e11b9461.svg";